import { Flex, Table, Tbody, Td, Tr } from '@chakra-ui/react'
import type { UserMotivation } from 'BrokerTsLib/src/dtos'

import { ValidityBadge } from '@/components'

import { RowTableHeader } from '../RowTableHeader'
import { TableSection } from '../Section/TableSection'

export const UserMotivationSection = ({ userMotivation }: { userMotivation?: UserMotivation }) => {
  return (
    <TableSection
      sectionTitle={<Flex alignItems='center' gap={2}>
        <ValidityBadge valid={userMotivation?.motivationYesNo} />
        Motivace
      </Flex>} wide={true}>
      <Table variant={'simple'} fontSize={'md'} borderRadius={8}>
        <Tbody>
          <Tr>
            <RowTableHeader>Motivace</RowTableHeader>
            <Td>{userMotivation?.motivationYesNo ? 'Ano' : 'Ne'}</Td>
          </Tr>
          <Tr>
            <RowTableHeader>Oslovení, jméno a příjmení</RowTableHeader>
            <Td>{userMotivation?.salutation} {userMotivation?.nameAndSurname}</Td>
          </Tr>
          <Tr>
            <RowTableHeader>Adresa</RowTableHeader>
            <Td>
              {userMotivation?.streetAndNumber},<br />
              {userMotivation?.city}, {userMotivation?.postCode}
            </Td>
          </Tr>
          <Tr>
            <RowTableHeader>E-mail</RowTableHeader>
            <Td>{userMotivation?.email}</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableSection>
  )
}
